<template>
  <v-layout fill-height row>
    <v-flex xs6 style="height: calc(100vh - 44px)">
      <v-layout fill-height column>
        <v-flex xs5 grow>
          <OverwatchCard>
            <v-layout column style="height: 100%">
              <v-layout v-if="actionBoxMode == null" pl-2 pr-2 pt-2 style="height: 100%">
                <TaxiList
                  @editBooking="enterEditMode"
                  :setSelectedTaxi="setSelectedTaxi"
                  :selectedTaxi="selectedTaxi"
                  :rideTypes="rideTypes"
                  :taxis="taxis"
                  :rideTypeEtas="rideTypeEtas"
                  :bookings="bookings"
                ></TaxiList>
              </v-layout>
              <v-layout v-if="actionBoxMode == 'book'" pa-1 style="height: 100%">
                <v-dialog
                  persistent
                  v-model="createBookingDialog"
                  fullscreen
                  hide-overlay
                  eager
                  transition="dialog-bottom-transition"
                >
                  <template v-slot:activator="{ on }">
                    <SmallBookForm
                      @expand="actionBoxMode == 'book' ? createBookingDialog = true : editBookingDialog = true"
                      @close="cancel"
                      @madeBooking="madeBooking"
                      @updatedBooking="updatedBooking"
                      @locationsChanged="makeBookingLocationsChanged"
                      :bookingForm="bookingForm"
                      :expand="function() {
                      createBookingDialog = true;
                    }"
                    ></SmallBookForm>
                  </template>
                  <v-card style="background-color: #f4f5f9;">
                    <v-toolbar dark color="primary">
                      <v-btn icon dark @click="closeCreateBookingDialog">
                        <v-icon>close</v-icon>
                      </v-btn>
                      <v-toolbar-title>Create Booking</v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <LargeBookForm
                      @madeBooking="madeBooking"
                      @updatedBooking="updatedBooking"
                      @locationsChanged="makeBookingLocationsChanged"
                      v-if="createBookingDialog == true"
                      :bookingForm="bookingForm"
                    />
                  </v-card>
                </v-dialog>
              </v-layout>
              <v-flex px-4 pb-1 v-if="loadingEditBooking == true">
                <v-progress-linear indeterminate color="yellow darken-2"></v-progress-linear>
              </v-flex>
              <v-layout v-if="actionBoxMode == 'edit'" pa-1 style="height: 100%">
                <v-dialog
                  v-model="editBookingDialog"
                  fullscreen
                  hide-overlay
                  eager
                  transition="dialog-bottom-transition"
                >
                  <!-- TODO SHOW ERROR FOR LOADING BOOKING -->
                  <template v-slot:activator="{ on }">
                    <v-layout>
                      <SmallBookForm
                        @expand="actionBoxMode == 'book' ? createBookingDialog = true : editBookingDialog = true"
                        v-if="(editBookingDialog == false || editBookingDialog == null) && loadingEditBooking == false && bookingForm != null"
                        @cancelledBooking="cancelledBooking"
                        @close="cancel"
                        @updatedBooking="updatedBooking"
                        @locationsChanged="makeBookingLocationsChanged"
                        :bookingForm="bookingForm"
                        :expand="function() {
                      editBookingDialog = true;
                    }"
                        :updateMode="true"
                      />
                    </v-layout>
                  </template>
                  <v-card style="background-color: #f4f5f9;">
                    <v-toolbar dark color="secondary">
                      <v-btn icon dark @click="editBookingDialog = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                      <v-toolbar-title>Edit Booking {{ bookingForm.booking.id != null ? "#" + bookingForm.booking.id + " - " + bookingForm.booking.state : "" }}</v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-flex px-4 pb-1 v-if="loadingEditBooking">
                      <v-progress-linear indeterminate color="yellow darken-2"></v-progress-linear>
                    </v-flex>
                    <LargeBookForm
                      @updatedBooking="updatedBooking"
                      @cancelledBooking="cancelledBooking"
                      @locationsChanged="makeBookingLocationsChanged"
                      v-if="editBookingDialog == true && loadingEditBooking == false && bookingForm != null"
                      :bookingForm="bookingForm"
                      :updateMode="true"
                    />
                    <p v-if="editBookingError != null">{{ editBookingError }}</p>
                  </v-card>
                </v-dialog>
              </v-layout>
              <v-layout v-if="actionBoxMode == 'assign'" pa-1 style="height: 100%">
                <AssignTrip
                  :key="assign"
                  @cancel="cancel()"
                  :booking="bookingFromID(bookingToAssign)"
                  :bookings="bookings"
                  :taxis="taxis"
                  :reassignMode="bookingFromID(bookingToAssign).state != 'booked'"
                />
              </v-layout>
              <v-layout row justify-space-between align-end pb-0 v-if="actionBoxMode == null">
                <v-layout align-end row>
                  <p style="font-size: 12px; font-weight: 500;">
                    &nbsp;&nbsp;{{ formatLastUpdateTime(lastUpdateTime)}} {{ lastUpdateSecondsAgo(lastUpdateTime) }}
                    <span
                      v-html="rideTypeAvailability()"
                    ></span>
                  </p>
                </v-layout>
                <v-btn
                  light
                  class="text-none"
                  small
                  :dark="actionBoxMode == null"
                  :color="actionBoxMode == null ? '#8268FC' : '' "
                  @click="makeBooking()"
                >Book Ride</v-btn>
              </v-layout>
            </v-layout>
          </OverwatchCard>
        </v-flex>
        <v-flex pt-1 xs7 grow>
          <OverwatchCard>
            <v-layout column>
              <ActiveTrips
                :setSelectedBooking="setSelectedBooking"
                :setSelectedTaxi="setSelectedTaxi"
                :selectedTaxi="selectedTaxi"
                :selectedBooking="selectedBooking"
                :taxis="taxis"
                :bookings="bookings"
                @reassign="enterAssignMode"
                @copy="enterCopyMode"
                @edit="enterEditMode"
                :hoursToShow="hoursToShowHistory"
                @changeHoursToShow="changeHoursToShowHistory"
                :history="history"
              ></ActiveTrips>
            </v-layout>
          </OverwatchCard>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex pa-1 xs6 grow>
      <OverwatchCard>
        <UpcomingTrips
          :setSelectedBooking="setSelectedBooking"
          :selectedBooking="selectedBooking"
          :taxis="taxis"
          :bookings="bookings"
          @assign="enterAssignMode"
          @copy="enterCopyMode"
          @edit="enterEditMode"
          :hoursToShow="hoursToShow"
          @changeHoursToShow="changeHoursToShow"
        ></UpcomingTrips>
      </OverwatchCard>
    </v-flex>
  </v-layout>
</template>

<script>
// @ is an alias to /src
import Home from "@/components/Home.vue";
import OverwatchCard from "@/components/widget/OverwatchCard.vue";
import OverwatchMap from "@/components/overwatch/OverwatchMap.vue";

import TaxiList from "@/components/overwatch/TaxiList.vue";

import AssignTrip from "@/components/booking/AssignTrip.vue";

import SmallBookForm from "@/components/booking/SmallBookForm.vue";

import LargeBookForm from "@/components/booking/LargeBookForm.vue";

import UpcomingTrips from "@/components/overwatch/UpcomingTrips.vue";
import ActiveTrips from "@/components/overwatch/ActiveTrips.vue";

import { BookingForm } from "@/components/util/BookingForm.js";

import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

import moment from "moment";

global.jQuery = require("jquery");
var $ = global.jQuery;

export default {
  name: "overwatch",
  components: {
    Home,
    OverwatchCard,
    OverwatchMap,
    TaxiList,
    UpcomingTrips,
    ActiveTrips,
    SmallBookForm,
    LargeBookForm,
    AssignTrip
  },
  data: function() {
    return {
      lastUpdateTime: null,
      createBookingDialog: false,
      editBookingDialog: false,
      loadingEditBooking: false,
      editBookingError: null,
      actionBoxMode: null,
      loading: true,
      rideTypes: [],
      taxis: [],
      history: [],
      bookings: [],
      rideTypeEtas: null,
      selectedTaxi: -1,
      selectedBooking: -1,
      bookingForm: null,
      bookingToAssign: null,
      hoursToShow: 18,
      hoursToShowHistory: 4,
      getInformationTimer: null,
      defaultTaxiList: null
    };
  },
  watch: {
    createBookingDialog: function(val) {
      console.log("Dialog changed " + val);

      var vm = this;
    }
  },
  beforeMount: function() {
    if (!this.$cookies.isKey("hoursToShow")) {
      this.$cookies.set("hoursToShow", 3, Infinity);
    }
    this.hoursToShow = parseInt(this.$cookies.get("hoursToShow"));

    if (!this.$cookies.isKey("hoursToShowHistory")) {
      this.$cookies.set("hoursToShowHistory", 3, Infinity);
    }
    this.hoursToShowHistory = parseInt(this.$cookies.get("hoursToShowHistory"));

    if (!this.$cookies.isKey("defaultTaxiList")) {
      this.$cookies.set("defaultTaxiList", null, Infinity);
    }
    this.defaultTaxiList = parseInt(this.$cookies.get("defaultTaxiList"));
  },
  created: function() {},
  beforeDestroy: function() {
    clearTimeout(this.getInformationTimer);
    this.getInformationTimer = null;
  },
  mounted: function() {
    var vm = this;

    this.getInformationTimer = setTimeout(function() {
      vm.getInformation();
      vm.getRideTypes();
    }, 2000);

    setTimeout(function() {
      $(document).on("click", function(e) {
        // console.log($(e.target)[0].id);
        // console.log($(e.target).attr("class"));

        var id = $(e.target)[0].id;

        if (id == "gridcontainer" || $(e.target).attr("class") == "flex") {
          // Clicked on blank space
          vm.selectedBooking = -1;
          vm.setSelectedTaxi(-1);
        }
      });
    }, 5000);
  },
  computed: {},
  methods: {
    changeHoursToShow(hours) {
      this.hoursToShow = hours;
      this.$cookies.set("hoursToShow", hours, Infinity);
    },
    changeHoursToShowHistory(hours) {
      this.hoursToShowHistory = hours;
      this.$cookies.set("hoursToShowHistory", hours, Infinity);
    },
    rideTypeAvailability: function() {
      var html = "";

      return html;
    },
    abbreviate: function(str1) {
      var split_names = str1.trim().split(" ");
      if (split_names.length > 1) {
        return split_names[0] + " " + split_names[1].charAt(0) + ".";
      }
      return split_names[0];
    },
    lastUpdateSecondsAgo: function(l) {
      return (
        "(" +
        ((new Date().getTime() - l.getTime()).toFixed() / 1000).toFixed(0) +
        " seconds ago" +
        ")"
      );
    },
    formatLastUpdateTime: function(l) {
      //YYYY-MM-DD
      return "Last Update " + moment(l).format("HH:mm:ss");
    },
    closeCreateBookingDialog: function() {
      this.createBookingDialog = false;

      var vm = this;
      vm.$nextTick(function() {
        this.createBookingDialog = false;
        vm.$forceUpdate();
      });
    },
    bookingFromID: function(id) {
      return this.bookings.find(function(b) {
        return b.id == id;
      });
    },
    madeBooking: function() {
      this.createBookingDialog = null;
      this.bookingForm = null;
      this.actionBoxMode = null;

      this.$refs.taxiMap.clear();
      this.$refs.taxiMap.recenter();
    },
    updatedBooking: function() {
      this.editBookingDialog = null;
      this.bookingForm = null;
      this.actionBoxMode = null;

      this.$refs.taxiMap.clear();
      this.$refs.taxiMap.recenter();
    },
    cancelledBooking: function() {
      this.editBookingDialog = null;
      this.bookingForm = null;
      this.actionBoxMode = null;

      this.$refs.taxiMap.clear();
      this.$refs.taxiMap.recenter();
    },
    makeBookingLocationsChanged: function(val) {
      console.log("Updating map");
      this.$refs.taxiMap.zoomToMakingBooking(this.bookingForm.booking);
    },
    makeBooking: function() {
      console.log("Showing booking action box");

      this.bookingForm = new BookingForm(this.rideTypes, "", this.$store);

      this.actionBoxMode = "book";
    },
    cancel: function() {
      console.log("Hiding booking action box");
      this.actionBoxMode = null;
      this.bookingToAssign = null;
      this.bookingForm = null;

      this.loadingEditBooking = false;
      this.editBookingError = null;
    },
    enterAssignMode: function(b) {
      this.cancel();

      var vm = this;

      vm.$nextTick(function() {
        vm.actionBoxMode = "assign";
        vm.bookingToAssign = b;
      });
    },
    enterCopyMode: function(booking) {
      this.cancel();

      var vm = this;

      vm.$nextTick(function() {
        vm.bookingForm = new BookingForm(vm.rideTypes, "", vm.$store);
        vm.bookingForm.copy(booking);
        vm.actionBoxMode = "book";
      });
    },
    async enterEditMode(b) {
      this.cancel();

      var vm = this;

      this.loadingEditBooking = true;

      vm.$nextTick(async function() {
        vm.actionBoxMode = "edit";
        console.log("EDIT MODE ");

        var booking = await vm.getBookingForEdit(b);

        console.log("booking");
        console.log(booking);

        if (typeof booking === "string") {
          console.log("Error for edit booking");
          this.editBookingError = booking;
        } else {
          var bookingUser = BookingForm.jsonToBookingFormBookingUser(booking);

          this.bookingForm = new BookingForm(
            this.rideTypes,
            bookingUser,
            this.$store
          );
        }

        this.loadingEditBooking = false;
      });
    },
    setSelectedBooking: function(bookingID, taxiID) {
      if (bookingID != -1) {
        this.setSelectedTaxi(-1);
      }

      if (this.selectedBooking == bookingID) {
        console.log("resetting");
        this.selectedBooking = -1;
        return;
      } else {
        this.selectedBooking = bookingID;
      }

      console.log("Booking ID " + bookingID);
      console.log("Taxi ID " + taxiID);

      var taxi = null;

      if (taxiID != null) {
        taxi = this.taxis.find(function(t) {
          return t.id == taxiID;
        });

        if (taxi != null) {
          this.selectedTaxi = taxi.id;
          console.log("Got taxi " + this.selectedTaxi);
        }

        try {
          if (this.selectedTaxi != -1) {
            var elem = document.getElementById(this.selectedTaxi);
            elem.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "nearest"
            });
          } else {
            var elem = document.getElementById("activeTable-header-row");
            elem.scrollIntoView(true);
          }
        } catch (e) {
          console.log(e);
          // taxi had no booking
        }
      }

      var booking = null;

      if (bookingID != -1) {
        booking = this.bookings.find(function(b) {
          return b.id == bookingID;
        });
      }

      if (booking == null) {
        console.log("Booking was null");
        return;
      }

      this.$refs.taxiMap.updateMarkers(this.selectedTaxi);
      this.$refs.taxiMap.zoomToBookingTaxi(booking, taxi);
    },
    setSelectedTaxi: function(taxiID) {
      if (taxiID != -1) {
        this.setSelectedBooking(-1);
      }

      console.log(taxiID);

      if (this.selectedTaxi == taxiID) {
        this.selectedTaxi = -1;
      } else {
        this.selectedTaxi = taxiID;
      }

      try {
        if (this.selectedTaxi != -1) {
          var elem = document.getElementById(this.selectedTaxi);
          elem.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest"
          });
        } else {
          var elem = document.getElementById("activeTable-header-row");
          elem.scrollIntoView(true);
        }
      } catch (e) {
        console.log(e);
        // taxi had no booking
      }

      try {
        // console.log(this);
        this.$refs.taxiMap.updateMarkers(this.selectedTaxi);
        this.$refs.taxiMap.zoomToTaxi(this.selectedTaxi);
      } catch (e) {
        console.log(e);
      }

      // highlight in table

      // highlight in summary
    },
    getInformation: async function() {
      this.loading = true;

      try {
        var url = `${
          this.$store.state.apiUrl
        }/overwatch/getInformation?hoursToShow=${
          this.hoursToShow == null ? 2 : this.hoursToShow
        }&historyToReturn=${
          this.hoursToShowHistory == null ? 0 : this.hoursToShowHistory
        }`;

        let response = await axios.get(url, {
          params: {}
        });

        // console.log(response.data);

        this.lastUpdateTime = new Date();

        this.taxis = response.data.taxis;
        this.bookings = response.data.jobs;
        this.history = response.data.history;

        if (this.history == null) {
          this.history = [];
        }

        this.rideTypeEtas = response.data.ride_type_eta;

        try {
          // console.log(this);
          this.$refs.taxiMap.updateMarkers(this.selectedTaxi);
        } catch (error) {
          console.log(error);
        }

        if (this.getInformationTimer != null) {
          setTimeout(this.getInformation.bind(this), 2000);
        }
      } catch (error) {
        this.loading = false;

        if (this.getInformationTimer != null) {
          setTimeout(this.getInformation.bind(this), 2000);
        }
        console.log("Failed to get information " + error);
      }
    },
    getRideTypes: async function() {
      try {
        var url = `${this.$store.state.apiUrl}/ride_types/all`;

        let response = await axios.get(url, {
          params: {}
        });

        this.rideTypes = response.data;

        console.log("got ride types");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
    async getBookingForEdit(bookingID) {
      try {
        var url = `${this.$store.state.apiUrl}/booking/${bookingID}/get`;

        let response = await axios.get(url, {
          params: {}
        });

        this.loadingEditBooking = false;

        if (response.error == null || response.error == "no_error") {
          return response.data;
        } else {
          return response.data.error;
        }
      } catch (error) {
        this.loadingEditBooking = false;

        console.log("Failed to get booking " + error);
        return "Unknown Error";
      }
    }
  }
};
</script>
